import React from 'react';

const IconArrowRight = props => (
  <svg width={18} height={12} viewBox="0 0 18 12" {...props}>
    <path
      fill="#333"
      d="M12 0l-1.05 1.05 4.2 4.2H0v1.5h15.15l-4.2 4.2L12 12l6-6z"
      fillRule="evenodd"
    />
  </svg>
);

export default IconArrowRight;
